const NumberInput = () => import("@/components/NumberInput/index");
import { OfflinePaymentService } from "@/services";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
const Attachment = () =>
  import("@/components/TicketsPage/CreateTicket/Attachment/index");
const AccountList = () =>
  import("@/components/OperationsPage/Deposit/Rial/Offline/AccountList/index");
const OfflinePaymentTable = () =>
  import(
    "@/components/OperationsPage/Deposit/Rial/Offline/OfflinePaymentTable/index"
  );

import dayjs from "dayjs";
import * as types from "@/store/types";
import { mapGetters } from "vuex";
export default {
  name: "offline",
  components: {
    NumberInput,
    datePicker: VuePersianDatetimePicker,
    Attachment,
    AccountList,
    OfflinePaymentTable,
  },
  props: ["directDepositCart"],
  data() {
    return {
      amount: "",
      depositTypes: [],
      depositType: "",
      selectedAccount: "",
      sourceBank: "",
      referralCode: "",
      createdFrom: "",
      isFromClosed: false,
      file: "",
      payDate: "",
      dialog: false,
      valid: false,
      showValidation: false,
      loading: false,
      publicUrl: process.env.VUE_APP_PUBLIC_BASE_URL,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: types.userInfo.getters.GET_USER_INFO,
    }),
    checkForm() {
      if (
        this.amount.length > 0 &&
        this.selectedAccount.id &&
        this.createdFrom.length > 0 &&
        this.referralCode.length > 0 &&
        this.sourceBank.length > 0
      )
        return false;
      else return true;
    },
  },
  mounted() {
    this.getAccount();
  },
  methods: {
    getAccount() {
      OfflinePaymentService.getAccount().then((response) => {
        this.depositTypes = response.data.data;
      });
    },
    fromDateTimestamp(date) {
      let UTCString = date._d.toUTCString();
      this.payDate = dayjs(UTCString).valueOf();
    },
    onOpen() {
      this.isToClosed = true;
    },
    onClose() {
      this.isToClosed = false;
    },
    clearCreatedFrom() {
      this.payDate = "";
    },
    offlinePaymentSubmit(e) {
      e.preventDefault();
      this.validation();
      if (this.valid) {
        this.loading = true;
        let data = new FormData();
        data.append("method_id", this.depositType.id);
        data.append("account_id", this.selectedAccount.id);
        data.append("file", this.file);
        data.append("origin_bank", this.sourceBank);
        data.append("reference_code", this.referralCode);
        data.append("amount", this.amount);
        data.append("pay_date", this.payDate);
        data.append("type", "offline_payment");
        OfflinePaymentService.storePayment(data)
          .then((response) => {
            this.$refs.form.reset();
            this.$router.push({
              path: `/submit-order/${response.data.data.id}/offline-deposit`,
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    validation() {
      this.valid = false;
      if (
        this.amount &&
        this.file &&
        this.depositType &&
        this.payDate &&
        this.sourceBank &&
        this.referralCode
      ) {
        this.valid = true;
        this.showValidation = false;
      } else {
        this.showValidation = true;
      }
    },
  },
};
